/**
 * Util function to return a promise which is resolved in provided milliseconds
 */
function waitFor(millSeconds) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, millSeconds);
  });
}

/**
 * Retries a promise with an specified delay when it fails
 * @param {Function} promise Promise to retry
 * @param {number} maxRetries Number of retries to attempt
 * @param {number} delayTime Time to wait between retries in milliseconds
 * @returns
 */
const retry = async (promise, maxRetries, delayTime, retryNumber = 0) => {
  try {
    const res = await promise();
    return res;
  } catch (e) {
    if (retryNumber >= maxRetries) {
      return Promise.reject(e);
    }

    // wait for delayTime amount of time before calling this method again
    await waitFor(delayTime);
    return retry(promise, maxRetries, delayTime, retryNumber + 1);
  }
};

export default retry;
